import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z","key":"svg-0"}],["path",{"d":"M12 8l0 .01","key":"svg-1"}],["path",{"d":"M8 12l0 .01","key":"svg-2"}],["path",{"d":"M12 12l0 .01","key":"svg-3"}],["path",{"d":"M16 12l0 .01","key":"svg-4"}],["path",{"d":"M12 16l0 .01","key":"svg-5"}]]

const IconBorderOuter = createReactComponent('outline', 'border-outer', 'BorderOuter', __iconNode);

export default IconBorderOuter;